var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLongArrowRight28 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 70,
  height: 28,
  viewBox: "0 0 70 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M64.8536 9.14645C64.6583 8.95118 64.3417 8.95118 64.1464 9.14645C63.9512 9.34171 63.9512 9.65829 64.1464 9.85355L67.2929 13H1.5C1.22386 13 1 13.2239 1 13.5C1 13.7761 1.22386 14 1.5 14H67.2929L64.1464 17.1464C63.9512 17.3417 63.9512 17.6583 64.1464 17.8536C64.3417 18.0488 64.6583 18.0488 64.8536 17.8536L68.8536 13.8536C69.0488 13.6583 69.0488 13.3417 68.8536 13.1464L64.8536 9.14645Z",
  fill: "currentColor"
})));
export { SvgLongArrowRight28 as ReactComponent };
export default __webpack_public_path__ + "b7ecd6db7a42b217fc5a04b6621443a7.svg";